(function(){
  "use strict";

  /* -------------------- Contexte & Namespace -------------------- */
  // Exposé par le thème : window.__wl = { userId, token, endpoint, shopOrigin }
  const WL      = window.__wl || {};
  const SHOP    = WL.shopOrigin || location.hostname;
  const CUR_UID = WL.userId ? String(WL.userId) : null;

  // Namespace commun à la boutique, puis sous-espace par userId ou "guest"
  const NS_PREFIX = `ly_wl:${SHOP}:`;
  const NS        = `${NS_PREFIX}${CUR_UID || 'guest'}`;

  // Clés locales NAMESPACEES
  const LS_KEY  = `${NS}:lists`;
  const REV_KEY = `${NS}:rev`;
  const LAST_KEY = `${NS_PREFIX}last_user`;

  // Purge les anciennes clés d’un autre utilisateur (ou passage compte -> guest)
  (function enforceNamespace(){
    const current = CUR_UID || 'guest';
    const prev = localStorage.getItem(LAST_KEY);
    if (prev && prev !== current) {
      const toDelete = [];
      for (let i = 0; i < localStorage.length; i++) {
        const k = localStorage.key(i);
        if (k && k.startsWith(NS_PREFIX) && !k.startsWith(NS)) toDelete.push(k);
      }
      toDelete.forEach(k => localStorage.removeItem(k));
    }
    localStorage.setItem(LAST_KEY, current);
  })();

  const PAGE    = document.querySelector(".ly-wl-page");
  const IS_AUTH = !!WL.userId && !!WL.token && !!WL.endpoint;

  /* -------------------- Helpers -------------------- */
  const qs  = (s, r=document) => r.querySelector(s);
  const qsa = (s, r=document) => Array.from(r.querySelectorAll(s));
  const getMODAL  = () => document.getElementById("ly-wl-modal");
  const getSELECT = () => document.getElementById("ly-wl-select");
  const getFEED   = () => document.getElementById("ly-wl-feedback");

  const uid    = () => "wl_" + Math.random().toString(36).slice(2,10);
  const nowISO = () => new Date().toISOString().slice(0,19) + "Z";
  const moneyFmt = (cents) =>
    (cents/100).toLocaleString(undefined, {
      style:"currency",
      currency:(window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR"
    });

  /* -------------------- Storage local (namespacé) -------------------- */
  const readLocal  = () => { try { return JSON.parse(localStorage.getItem(LS_KEY)) || []; } catch(_){ return []; } };
  const writeLocal = (arr) => localStorage.setItem(LS_KEY, JSON.stringify(arr));
  const getRev     = () => parseInt(localStorage.getItem(REV_KEY) || "0", 10);
  const setRev     = (n) => localStorage.setItem(REV_KEY, String(n));

  function ensureDefault(){
    const w = readLocal();
    if (!w.length){
      writeLocal([{ id: uid(), name: "Ma wishlist", created_at: nowISO(), products: [] }]);
      setRev(getRev()+1);
    }
  }
  ensureDefault();

  /* -------------------- Envelope (KV schema) -------------------- */
  // { user_id, rev, updated_at, lists:[ {id,name,created_at,products:[{id,title,handle,image,price}]} ] }
  function localToEnvelope(){
    return { user_id: WL.userId || null, rev: getRev(), updated_at: nowISO(), lists: readLocal() };
  }
  function applyEnvelopeToLocal(env){
    if (!env || !Array.isArray(env.lists)) return;
    writeLocal(env.lists);
    setRev(env.rev || 0);
  }

  /* -------------------- Network (pull/push/merge) -------------------- */
  async function wlFetch(path, method, body){
    if (!IS_AUTH) return null;
    const url = WL.endpoint.replace(/\/$/,"") + path;
    const res = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        "X-WL-User": String(WL.userId),
        "X-WL-Token": WL.token,
        "X-WL-Shop": WL.shopOrigin || location.origin
      },
      body: body ? JSON.stringify(body) : undefined,
      cache: "no-store",
      credentials: "omit",
      keepalive: true
    });
    if (!res.ok) throw new Error(`WL ${method} ${path} ${res.status}`);
    return await res.json();
  }

  async function pullFromKV(){
    if (!IS_AUTH) return;
    const data = await wlFetch(`/pull?rev=${encodeURIComponent(getRev())}`, "GET");
    if (data.status === "ok" && data.payload) applyEnvelopeToLocal(data.payload);
    return data.status;
  }

  let pushTimer = null;
  function schedulePush(){
    if (!IS_AUTH) return;
    clearTimeout(pushTimer);
    pushTimer = setTimeout(()=>pushToKV(), 300);
  }

  async function pushToKV(){
    if (!IS_AUTH) return;
    const env = localToEnvelope();
    const data = await wlFetch("/push", "POST", env);
    if (data.status === "ok" && data.payload) applyEnvelopeToLocal(data.payload);
  }

  async function mergeIntoKV(){
    if (!IS_AUTH) return;
    const env = localToEnvelope();
    const data = await wlFetch("/merge", "POST", env);
    if (data.status === "ok" && data.payload) applyEnvelopeToLocal(data.payload);
  }

  /* -------------------- API locale (CRUD) -------------------- */
  const listNames = () => readLocal().map(x => ({ id:x.id, name:x.name }));

  function createWishlist(name){
    const w = readLocal();
    const n = name && name.trim() ? name.trim() : `Wishlist ${w.length+1}`;
    const item = { id: uid(), name: n, created_at: nowISO(), products: [] };
    w.push(item); writeLocal(w); setRev(getRev()+1); schedulePush();
    return item;
  }
  function renameWishlist(id, newName){
    const w = readLocal(); const t = w.find(x=>x.id===id); if(!t) return;
    t.name = newName.trim() || t.name; writeLocal(w); setRev(getRev()+1); schedulePush();
  }
  function deleteWishlist(id){
    let w = readLocal().filter(x=>x.id!==id);
    if (!w.length) w = [{ id: uid(), name:"Ma wishlist", created_at: nowISO(), products: [] }];
    writeLocal(w); setRev(getRev()+1); schedulePush();
  }
  function addProduct(listId, prod){
    const w = readLocal(); const t = w.find(x=>x.id===listId); if(!t) return false;
    const exists = t.products.some(p=>String(p.id)===String(prod.id));
    if (!exists) { t.products.push(prod); writeLocal(w); setRev(getRev()+1); schedulePush(); }
    return !exists;
  }
  function removeProduct(listId, pid){
    const w = readLocal(); const t = w.find(x=>x.id===listId); if(!t) return;
    t.products = t.products.filter(p=>String(p.id)!==String(pid));
    writeLocal(w); setRev(getRev()+1); schedulePush();
  }

  /* -------------------- Payload produit (PDP) -------------------- */
  function readProductPayloadById(pid){
    const node = document.getElementById(`ly-wl-json-${pid}`);
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch(_){ return null; }
  }

  /* -------------------- Modal + a11y -------------------- */
  let lastFocused = null;
  function openModal(){
    const MODAL = getMODAL(); const SELECT = getSELECT(); const FEED = getFEED();
    if (!MODAL || !SELECT) return;
    lastFocused = document.activeElement;
    MODAL.setAttribute("aria-hidden","false");
    SELECT.innerHTML = "";
    listNames().forEach(n=>{
      const o = document.createElement("option");
      o.value = n.id; o.textContent = n.name; SELECT.appendChild(o);
    });
    if (FEED) FEED.textContent = "";
    const dialog = qs(".ly-wl-modal__dialog", MODAL);
    dialog && dialog.focus && dialog.focus();
  }
  function closeModal(){
    const MODAL = getMODAL(); if (!MODAL) return;
    (document.activeElement && document.activeElement.blur) && document.activeElement.blur();
    MODAL.setAttribute("aria-hidden","true");
    delete MODAL.dataset.pendingProduct;
    if (lastFocused && lastFocused.focus) { try { lastFocused.focus(); } catch(_){ } }
  }
  document.addEventListener("click", (e)=>{
    const MODAL = getMODAL(); if (!MODAL) return;
    if (e.target.matches("#ly-wl-modal [data-close]") || e.target === MODAL) closeModal();
  });

  /* -------------------- Boutons cœur -------------------- */
  function markHearts(productId, state){
    qsa(`.ly-wl-btn[data-product-id="${CSS.escape(String(productId))}"]`)
      .forEach(btn => btn.setAttribute("aria-pressed", state ? "true" : "false"));
  }
  const productIsInAnyWL = (pid) =>
    readLocal().some(w => w.products.some(p=>String(p.id)===String(pid)));

  document.addEventListener("click", (e)=>{
    const btn = e.target.closest(".ly-wl-btn"); if (!btn) return;
    const pid = btn.getAttribute("data-product-id"); if (!pid) return;

    const payload = readProductPayloadById(pid); if (!payload) return;
    if (!payload.image){
      const img = qs(`[data-product-id="${CSS.escape(pid)}"] img`);
      payload.image = img?.currentSrc || img?.src || null;
    }
    // ✅ vendor (si présent dans le JSON, sinon tentative DOM)
if (!payload.vendor) {
  const vendorNode =
    document.querySelector(`[data-product-id="${CSS.escape(pid)}"] [data-ly-vendor]`) ||
    document.querySelector(`[data-product-id="${CSS.escape(pid)}"] .card__vendor`) ||
    document.querySelector(`[data-product-id="${CSS.escape(pid)}"] .product-card__vendor`);
  payload.vendor = vendorNode ? vendorNode.textContent.trim() : "";
}
    const MODAL = getMODAL(); if (!MODAL) return;
    MODAL.dataset.pendingProduct = JSON.stringify(payload);
    openModal();
  });

  document.addEventListener("click", (e)=>{
    if (!e.target.closest("#ly-wl-add-btn")) return;
    const MODAL = getMODAL(); const SELECT = getSELECT(); const FEED = getFEED();
    if (!MODAL || !SELECT) return;
    const selected = SELECT.value;
    const prodJSON = MODAL.dataset.pendingProduct;
    if (!selected || !prodJSON) return;
    const prod = JSON.parse(prodJSON);
    const added = addProduct(selected, prod);
    if (FEED) FEED.textContent = added ? `Produit ajouté à ${SELECT.options[SELECT.selectedIndex].text}` : "Déjà présent dans cette wishlist";
    markHearts(prod.id, true);
    setTimeout(closeModal, 4000);
  });

  document.addEventListener("click", (e)=>{
  const btn = e.target.closest("#ly-wl-create-btn");
  if (!btn) return;

  const MODAL  = getMODAL();
  const INPUT  = document.getElementById("ly-wl-new-name");
  const SELECT = getSELECT();
  const FEED   = getFEED();

  if (!MODAL || !INPUT || !SELECT) return;

  const name = INPUT.value.trim();
  if (!name) {
    FEED && (FEED.textContent = "Veuillez saisir un nom de wishlist");
    return;
  }

  // 1. Créer la wishlist
  const newList = createWishlist(name);

  // 2. Rafraîchir le select
  SELECT.innerHTML = "";
  listNames().forEach(n=>{
    const o = document.createElement("option");
    o.value = n.id;
    o.textContent = n.name;
    SELECT.appendChild(o);
  });

  // 3. Sélectionner la nouvelle wishlist
  SELECT.value = newList.id;

  // 4. Ajouter le produit en attente
  const prodJSON = MODAL.dataset.pendingProduct;
  if (prodJSON) {
    const prod = JSON.parse(prodJSON);
    addProduct(newList.id, prod);
    markHearts(prod.id, true);
  }

  FEED && (FEED.textContent = `Produit ajouté à ${newList.name}`);

  // 5. Fermer la modale
  setTimeout(closeModal, 4000);
});

  qsa(".ly-wl-btn").forEach(btn=>{
    const pid = btn.getAttribute("data-product-id");
    if (pid && productIsInAnyWL(pid)) btn.setAttribute("aria-pressed","true");
  });

  /* -------------------- Page /pages/wishlist -------------------- */
  if (PAGE){
    const listNode = document.getElementById("ly-wl-list");
    const cardTpl  = document.getElementById("ly-wl-card-tpl");
    const itemTpl  = document.getElementById("ly-wl-item-tpl");

function render(){
  listNode.innerHTML = "";
  const wls = readLocal();

  wls.forEach(w=>{
    const card = cardTpl.content.cloneNode(true);
    const wrap = qs(".ly-wl-card", card);
    wrap.dataset.wid = w.id;

    const renameInput = qs(".ly-wl-rename-input", card);
    renameInput.value = w.name;

    // Bouton Renommer
    const renameBtn = qs(".js-wl-rename", card);
    if (renameBtn) {
      renameBtn.addEventListener("click", ()=>{
        renameWishlist(w.id, renameInput.value);
        render();
      });
    }

    // Bouton Supprimer
    const deleteBtn = qs(".js-wl-delete", card);
    if (deleteBtn) {
      deleteBtn.addEventListener("click", ()=>{
        deleteWishlist(w.id);
        render();
      });
    }

    // Bouton Partager
    const shareBtn = qs(".js-wl-share", card);
    if (shareBtn) {
      shareBtn.addEventListener("click", ()=>{
        const share = `${location.origin}/pages/wishlist?id=${encodeURIComponent(w.id)}`;
        navigator.clipboard?.writeText(share);
        alert("Lien copié : " + share);
      });
    }

    // Bouton Export CSV
    const exportBtn = qs(".js-wl-export", card);
    if (exportBtn) {
      exportBtn.addEventListener("click", ()=> exportCSV(w));
    }

    // Bouton Devis
    const quotesUrl =
      qs("[data-ly-quotes-url]")?.getAttribute("data-ly-quotes-url") ||
      window.lyQuotesUrl || "/pages/devis";
    const quoteBtn = qs(".js-wl-quote", card);
    if (quoteBtn) {
      quoteBtn.href = `${quotesUrl}?wishlist=${encodeURIComponent(w.id)}`;
    }

    // Bouton Imprimer (optionnel, tu peux garder ou supprimer le bouton HTML)
    const printBtn = qs(".js-wl-print", card);
    if (printBtn) {
      printBtn.addEventListener("click", ()=> window.print());
    }

    const grid = qs(".ly-wl-grid", card);
    w.products.forEach(p=>{
      const item = itemTpl.content.cloneNode(true);
      const root = qs(".ly-wl-item", item);
      root.dataset.pid = p.id;

      const a = qs(".ly-wl-thumb", item); a.href = `/products/${p.handle}`;
      const img = qs("img", item); img.src = p.image || ""; img.alt = p.title || "";
      const t = qs(".ly-wl-title", item); t.textContent = p.title; t.href = `/products/${p.handle}`;
      const pr = qs(".ly-wl-price", item); pr.textContent = p.price ? moneyFmt(p.price) : "";
      const v = qs(".ly-wl-vendor", item);
if (v) {
  v.textContent = (p.vendor || "").trim();
  if (!v.textContent) v.style.display = "none"; // cache si vide
}

      qs(".ly-wl-remove", item).addEventListener("click", ()=>{
        removeProduct(w.id, p.id);
        markHearts(p.id,false);
        render();
      });

      grid.appendChild(item);
    });

    listNode.appendChild(card);
  });
}
    function exportCSV(w){
      const lines = [["id","title","handle","image","price"]];
      w.products.forEach(p=> lines.push([p.id,p.title,p.handle,p.image,(p.price||0)/100]));
      const csv = lines.map(r=>r.map(v=>{
        const s = String(v ?? ""); return `"${s.replace(/"/g,'""')}"`;
      }).join(",")).join("\n");
      const blob = new Blob([csv],{type:"text/csv;charset=utf-8;"});
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = `${w.name.replace(/\s+/g,'_')}.csv`; a.click();
      setTimeout(()=>URL.revokeObjectURL(url), 400);
    }

    qs("#ly-wl-create-btn-page")?.addEventListener("click", ()=>{
      const name = qs("#ly-wl-new-name-page")?.value?.trim() || "";
      createWishlist(name); render();
    });

    const params = new URLSearchParams(location.search);
    const focusId = params.get("id");
    render();
    if (focusId){
      const target = qs(`.ly-wl-card[data-wid="${CSS.escape(focusId)}"]`);
      target?.scrollIntoView({behavior:"smooth",block:"start"});
    }
  }

  /* -------------------- Sync au boot -------------------- */
  (async function initSync(){
    if (!IS_AUTH) return; // visiteur: local only
    try {
      const status = await pullFromKV();
      if (status === "empty") {
        await mergeIntoKV();
      } else if (status === "conflict") {
        await mergeIntoKV();
      }
    } catch(e){
      console.warn("WL sync error:", e.message);
    }
  })();

})();